import styled from 'styled-components';
import { BORDER_GRAY, WHITE } from '../../../theme';

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding:  24px;
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 16px 24px;
  border-bottom: 1px solid ${BORDER_GRAY};
  background: ${WHITE};

  position: sticky;
  top: 0;
  z-index: 10;
`;
